import { RouteConfig } from "vue-router";
import Sell from "./views/sell/Sell.vue";
import SellDetails from "./views/sell-details/SellDetails.vue";

export default [
  {
    path: "/dashboard/sell",
    component: Sell,
    meta: { title: "Sell" },
  },
  {
    path: "/dashboard/sell/details",
    component: SellDetails,
    props: (route) => route.query,
    meta: { title: "Sell Details" },
  },
] as RouteConfig[];
